module.exports = __webpack_public_path__ + "static/media/commenting.56fe74ca.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/commenting.webm
// module id = 70
// module chunks = 0